/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import {
  Row,
  Col,
  Button,
  Tooltip,
  Dropdown,
  Menu,
  Space,
  Checkbox,
} from 'antd'
import { useDispatch } from 'react-redux'
import AppLayout from '../../components/layout/layout'
import { Tabs } from 'antd'
import actions from '../../Redux/Organization/action'
import printerImg from '../../assets/Images/Printer.svg'
import downloadImg from '../../assets/Images/Download.svg'
import statusimg from '../../assets/Images/Activity.svg'
import deleteImg from '../../assets/Images/delete_white.svg'
import Statusmodal from '../../helper/Statusmodal'
import OrganazationsDataType from './types'
import OrganizationTable from './Table/OrganizationTable'
import OrganizationalModal from '../../components/modals/organizationModal'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { changeOrganizationStatus, getOrganizations } from 'api/Organizations'
import { GetRequestParams, RequestParms } from 'types/globalTypes'
import Spinner from 'components/Spinner'
import { forceRefetch } from 'helper/utility'
import { DownOutlined, SearchOutlined } from '@ant-design/icons'
import ExportOrganization from './ExportOrganization'
import FilePlus from 'assets/Images/FilePlus.svg'
import ImportOrganization from './ImportOrganization'
import { organizationStore } from 'state/organization/organization'
import CreateOrganization from './Modals/CreateOrganization'
import { useSyncParamsWithRoute } from 'hooks/useUpdateSearchParams'
import { debounce } from 'lodash'
import filterSvg from 'assets/Images/filter.svg'

const { TabPane } = Tabs
const Oraganazation = () => {
  const {
    organizeationModalVisible,
    setOrganizationModalVisible,
    setIsUpdating,
    setOrganizationData,
    setCounter,
  } = organizationStore(store => ({
    organizeationModalVisible: store.organizationModalVisible,
    setOrganizationModalVisible: store.setOrganizationModalVisible,
    setIsUpdating: store.setIsUpdating,
    setOrganizationData: store.setOrganizationData,
    setCounter: store.setOrganizationCurrentStep,
  }))
  const [activeData, setActiveData] = useState<OrganazationsDataType[]>([])
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [selectedRows, setSelectedRows] = useState([])
  const [someState, setSomeState] = useState(1)
  const [visible, setVisible] = useState(false)
  const dispatch = useDispatch()
  const onChangeSomeState = (newSomeState: any) => {
    setSomeState(newSomeState)
  }
  const [parms, setParams] = useState<RequestParms & GetRequestParams>({
    sort: '-createdAt',
    page: 1,
    limit: 10,
    status: 'approved',
    queryString: undefined,
  })
  const [hiddenColumns, setHiddenColumns] = useState<any>({
    organizationName: true,
    owner: true,
    referralType: true,
    dateApplied: true,
    status: true,
    action: true,
  })
  const searchInputRef = useRef<HTMLInputElement>(null)

  const { updateRouteParams } = useSyncParamsWithRoute(parms, setParams)

  const { data, isLoading, refetch, isFetching } = useQuery(
    ['getOrganization-listing'],
    {
      queryFn: () => getOrganizations(parms),
      enabled: false,
    },
  )
  const onChangeColumnCheckBox = (e: any) => {
    const updatedHiddenColumns = {
      ...hiddenColumns,
      [e.target.name]: e.target.checked,
    }

    setHiddenColumns(updatedHiddenColumns)
    localStorage.setItem(
      'OrganizationCols',
      JSON.stringify(updatedHiddenColumns),
    )
  }

  const menu2 = (
    <Menu
      title="show all"
      items={[
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hiddenColumns.organizationName}
                  name="organizationName"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Organization Name</Col>
            </Row>
          ),
          key: 1,
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hiddenColumns.owner}
                  name="owner"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Admin Name </Col>
            </Row>
          ),
          key: 2,
        },

        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hiddenColumns.dateApplied}
                  name="createdAt"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Date Created At</Col>
            </Row>
          ),
          key: 4,
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hiddenColumns.status}
                  name="status"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>status</Col>
            </Row>
          ),
          key: 5,
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hiddenColumns.action}
                  name="action"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Action</Col>
            </Row>
          ),
          key: 6,
        },
      ]}
    />
  )

  const handleVisibleChange = (flag: boolean) => {
    setVisible(flag)
  }

  const handleSearchChange = (searchValue: string) => {
    setParams((prevParms: any) => ({
      ...prevParms,
      queryString: searchValue,
    }))
  }
  const debounced = debounce(handleSearchChange, 600)

  useEffect(() => {
    if (parms.page && parms.status) {
      refetch()
    }
  }, [parms])
  const queryClient = useQueryClient()
  const changeMutation = useMutation({
    mutationFn: async ({ params, payload }: any) => {
      return await changeOrganizationStatus(params, payload)
    },
    onSuccess: () => {
      forceRefetch('getOrganization-listing', queryClient)
      refetch()
    },
  })
  const deleteOrganization: any = (activeItem: any) => {
    dispatch({
      type: actions.DELETE_ORGANIZATION_DATA,
      payload: activeItem.id,
    })
  }
  const [alertModalVisible, setAlertModalVisible] = useState(false)

  const deleteMultipleRecords = () => {
    let _data = [...activeData]
    selectedRows.forEach((row: any) => {
      _data = _data.filter(t => t.id !== row.key)
    })
    setActiveData(_data)
    dispatch({
      type: actions.ADD_ORGANIZATION_DATA,
      payload: _data,
    })
  }
  const alertModalData = {
    heading: 'Status changed',
    message1: 'Save',
  }

  const handleImportClick = () => {
    setIsImportModalVisible(true)
  }

  // calling the correct method based on the condition
  function TabCallback(key: any) {
    if (searchInputRef.current) {
      searchInputRef.current.value = ''
    }
    if (key == 'active') {
      // setParams({ ...parms, page: 1, status: 'approved', queryString: '' })
      updateRouteParams({ page: 1, status: 'approved', queryString: undefined })
    } else if (key == 'pending') {
      // setParams({ ...parms, page: 1, status: 'under_review', queryString: '' })
      updateRouteParams({
        page: 1,
        status: 'under_review',
        queryString: undefined,
      })
    } else if (key == 'archived') {
      updateRouteParams({
        page: 1,
        status: 'archived',
        queryString: undefined,
      })
    }
  }
  const headers = [
    { label: 'key', key: 'key' },
    { label: 'Organization Name', key: 'organizationName' },
    { label: 'Admin Name', key: 'adminName' },
    { label: 'Refferal type', key: 'referralType' },
    { label: 'Date applied  ', key: 'EstablishedDate' },
    { label: 'Status', key: 'status' },
  ]
  const [isExportModalVisible, setExportModalVisible] = useState(false)
  const [isImportModalVisible, setIsImportModalVisible] = useState(false)
  const handleModalClose = () => {
    setExportModalVisible(false)
  }
  const handleExportClick = () => {
    setExportModalVisible(true)
  }
  const handleImportModalClose = () => {
    setIsImportModalVisible(false)
  }
  const [newOrganization, setnewOrg] = useState(false)
  const menu = (
    <Menu>
      <Menu.Item>
        <Space onClick={handleExportClick}>
          <img alt="img" src={downloadImg} /> Export
        </Space>
        <Space className="mt-10" onClick={handleImportClick}>
          <img alt="importIcon" src={FilePlus} /> Import
        </Space>
      </Menu.Item>
    </Menu>
  )

  const hanldeAddOrganization = () => {
    setIsUpdating(false)
    setOrganizationData(null)
    setCounter(0)
    setOrganizationModalVisible(true)
  }

  return (
    <AppLayout>
      <Row className="page-header" justify="space-between">
        <Col lg={{ span: 6 }} xs={{ span: 24 }}>
          <h1 className="table-head mb-0">Organizations</h1>
        </Col>
        <Col lg={{ span: 18 }} offset={6} xs={{ span: 24, offset: 0 }}>
          {selectedRows?.length > 0 ? (
            <Space
              className="organizations-table-onselect-btn"
              size={10}
              align="end"
            >
              <Tooltip placement="bottom" title="Status" color="blue">
                <Button
                  className={'bg-grey br-8'}
                  icon={
                    <img
                      alt="img"
                      src={statusimg}
                      style={{
                        padding: '1%',
                        height: '20px',
                        marginRight: '10px',
                      }}
                    ></img>
                  }
                  onClick={() => {
                    setAlertModalVisible(true)
                  }}
                >
                  Status
                </Button>
              </Tooltip>
              <Tooltip placement="bottom" title="Print" color="blue">
                <Button
                  className={'bg-grey br-8'}
                  onClick={() => {
                    window.print()
                  }}
                  icon={
                    <img
                      alt="img"
                      src={printerImg}
                      style={{
                        padding: '1%',
                        height: '20px',
                        marginRight: '10px',
                      }}
                    ></img>
                  }
                >
                  Print
                </Button>
              </Tooltip>
              <Tooltip placement="bottom" title="Export" color="blue">
                <Button
                  className={'bg-grey br-8'}
                  icon={<img alt="img" src={downloadImg}></img>}
                >
                  {/* <CSVLink
                    data={csvData}
                    headers={headers}
                    style={{
                      color: 'black',
                      padding: '1%',
                      height: '20px',
                      marginRight: '10px',
                    }}
                    filename="OraganizationsData.csv"
                    target="_blank"
                  >
                    Export
                  </CSVLink> */}
                </Button>
              </Tooltip>
              <Tooltip placement="bottom" title="Delete" color="blue">
                <Button
                  className={'bg-grey br-8'}
                  onClick={() => {
                    deleteMultipleRecords()
                  }}
                  icon={
                    <img
                      alt="img"
                      src={deleteImg}
                      style={{
                        padding: '1%',
                        height: '20px',
                        marginRight: '10px',
                      }}
                    ></img>
                  }
                >
                  Delete
                </Button>
              </Tooltip>
            </Space>
          ) : (
            <div className="right-search-block">
              <div
                className="table-action-btn new-organizations-export-btn"
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  width: '100%',
                }}
              >
                {localStorage.getItem('role') === 'admin' && (
                  <Dropdown
                    overlay={menu}
                    placement="bottom"
                    className="bg-grey mx-20px"
                  >
                    <button className=" prim-sm-btn" style={{ color: 'black' }}>
                      More <DownOutlined />
                    </button>
                  </Dropdown>
                )}

                <Tooltip placement="bottom" title="Create">
                  <Button
                    className={'btn-new primary br-8'}
                    // onClick={() => {
                    //   setnewOrg(true)
                    // }}
                    onClick={hanldeAddOrganization}
                  >
                    New organization
                  </Button>
                </Tooltip>
              </div>
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col style={{ width: '100%' }}>
          <Tabs
            className="orgn-tabs"
            activeKey={
              parms.status === 'approved'
                ? 'active'
                : parms.status === 'archived'
                ? 'archived'
                : 'pending'
            }
            onChange={TabCallback}
          >
            <TabPane tab="Active" key="active">
              <Space
                size={20}
                align="center"
                className="mentors-table-header"
                style={{ width: '100%' }}
              >
                <Dropdown
                  overlay={menu2}
                  onOpenChange={handleVisibleChange}
                  open={visible}
                >
                  <a onClick={e => e.preventDefault()}>
                    <Space>
                      <img src={filterSvg} alt=""></img>
                    </Space>
                  </a>
                </Dropdown>
                <div className="search-box">
                  <div
                    className="right-search-block w-100 d-inline-block"
                    style={{ maxWidth: '100%' }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        width: '100%',
                      }}
                    >
                      <div
                        className={'search-input-box'}
                        style={{ marginRight: '15px' }}
                      >
                        <input
                          ref={searchInputRef}
                          type="search"
                          className="search-input-group"
                          placeholder="Search by name"
                          onChange={e => {
                            e.preventDefault()
                            debounced(e.target.value)
                          }}
                        />

                        <SearchOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </Space>
              <Row>
                <Col style={{ alignItems: 'center', width: '100%' }}>
                  {isLoading || isFetching ? (
                    <div
                      className="flex justify-center aligin-center items-center "
                      style={{ height: '80vh' }}
                    >
                      <Spinner />
                    </div>
                  ) : (
                    <OrganizationTable
                      activeData={data}
                      parms={parms}
                      setParms={setParams}
                      setEditModalVisible={setEditModalVisible}
                      setSelectedRows={setSelectedRows}
                      someState={someState}
                      onChangeSomeState={onChangeSomeState}
                      status="approved"
                      changeStatus={changeMutation}
                      refetchOrg={refetch}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Pending" key="pending">
              <Space
                size={20}
                align="center"
                className="mentors-table-header"
                style={{ width: '100%' }}
              >
                <Dropdown
                  overlay={menu2}
                  onOpenChange={handleVisibleChange}
                  open={visible}
                >
                  <a onClick={e => e.preventDefault()}>
                    <Space>
                      <img src={filterSvg} alt=""></img>
                    </Space>
                  </a>
                </Dropdown>
                <div className="search-box">
                  <div
                    className="right-search-block w-100 d-inline-block"
                    style={{ maxWidth: '100%' }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        width: '100%',
                      }}
                    >
                      <div
                        className={'search-input-box'}
                        style={{ marginRight: '15px' }}
                      >
                        <input
                          ref={searchInputRef}
                          type="search"
                          className="search-input-group"
                          placeholder="Search by name"
                          onChange={e => {
                            e.preventDefault()
                            debounced(e.target.value)
                          }}
                        />

                        <SearchOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </Space>
              <Row style={{ width: '100%' }}>
                <Col style={{ alignItems: 'center', width: '100%' }}>
                  {isLoading || isFetching ? (
                    <div
                      className="flex justify-center aligin-center items-center "
                      style={{ height: '80vh' }}
                    >
                      <Spinner />
                    </div>
                  ) : (
                    <OrganizationTable
                      activeData={data}
                      setParms={setParams}
                      parms={parms}
                      setEditModalVisible={setEditModalVisible}
                      setSelectedRows={setSelectedRows}
                      someState={someState}
                      onChangeSomeState={onChangeSomeState}
                      status="under_review"
                      changeStatus={changeMutation}
                      refetchOrg={refetch}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Archived" key="archived">
              <Space
                size={20}
                align="center"
                className="mentors-table-header"
                style={{ width: '100%' }}
              >
                <Dropdown
                  overlay={menu2}
                  onOpenChange={handleVisibleChange}
                  open={visible}
                >
                  <a onClick={e => e.preventDefault()}>
                    <Space>
                      <img src={filterSvg} alt=""></img>
                    </Space>
                  </a>
                </Dropdown>
                <div className="search-box">
                  <div
                    className="right-search-block w-100 d-inline-block"
                    style={{ maxWidth: '100%' }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        width: '100%',
                      }}
                    >
                      <div
                        className={'search-input-box'}
                        style={{ marginRight: '15px' }}
                      >
                        <input
                          ref={searchInputRef}
                          type="search"
                          className="search-input-group"
                          placeholder="Search by name"
                          onChange={e => {
                            e.preventDefault()
                            debounced(e.target.value)
                          }}
                        />

                        <SearchOutlined />
                      </div>
                    </div>
                  </div>
                </div>
              </Space>
              <Row style={{ width: '100%' }}>
                <Col style={{ alignItems: 'center', width: '100%' }}>
                  {isLoading || isFetching ? (
                    <div
                      className="flex justify-center aligin-center items-center "
                      style={{ height: '80vh' }}
                    >
                      <Spinner />
                    </div>
                  ) : (
                    <OrganizationTable
                      activeData={data}
                      setParms={setParams}
                      parms={parms}
                      setEditModalVisible={setEditModalVisible}
                      setSelectedRows={setSelectedRows}
                      someState={someState}
                      onChangeSomeState={onChangeSomeState}
                      status="archived"
                      changeStatus={changeMutation}
                      refetchOrg={refetch}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </Col>
      </Row>
      {alertModalVisible && (
        <Statusmodal
          isModalVisible={alertModalVisible}
          setIsModalVisible={setAlertModalVisible}
          data={alertModalData}
          name="organization"
          selectedRows={selectedRows}
        ></Statusmodal>
      )}
      {/* {newOrganization && (
        <OrganizationalModal visible={newOrganization} setVisblie={setnewOrg} />
      )} */}
      {organizeationModalVisible && <CreateOrganization />}
      <ExportOrganization
        visible={isExportModalVisible}
        onClose={handleModalClose}
        data={data?.records}
      />
      {isImportModalVisible && (
        <ImportOrganization
          visible={isImportModalVisible}
          onClose={handleImportModalClose}
        />
      )}
    </AppLayout>
  )
}

export default Oraganazation
